import { network } from 'services/network';

import { Flags } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/RowsBoard/RowsBoardColumns.utils';
import { initialFiltersState } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';

export interface Payload {
    cardCachedFilter: {
        filter: (typeof initialFiltersState)['filter'];
        flags: Flags;
    };
    paging: { size: number; page: number };
    primaryGroupField: string;
    secondaryGroupField: string | null;
    currentDay: string; // date formatted as "YYYY-MM-DD" i.e. "2026-03-16"
}

export const getPivotTable = (params: Payload, endpoint: string, signal?: AbortSignal) => {
    return network.post<QueryResponse>(endpoint, params, { signal }).then((response) => {
        return response.data;
    });
};

export interface QueryResponse {
    groupList: PivotTableGroupDetails[];
}

export interface PivotTableGroupDetails {
    rowId: number;
    parentId: number | null;
    isPrimaryGroup: boolean;
    taskNum: number;
    name: string;
    todoPercent: string;
    inProgressPercent: string;
    donePercent: string;
    criticalPathPercent: number;
    lateFinishDelayedPercent: number;
    totalFloatAvg: number;
    lateStartAvg: number;
    lateStartDelayedPercent: number;
    lateStartEarlyPercent: number;
    lateFinishAvg: number;
    lateFinishEarlyPercent: number;
    durationAvg: number;
    durationOverrunPercent: number;
    durationUnderrunPercent: number;
    budgetResourceMedian: number;
    actualResourceMedian: number;
    remainingResourceMedian: number;
    criticalScoreMedian: number;
    completedDurationMedian: number;
    completedDurationP80: number;
    criticalityPlannedPercent: number;
    criticalityActualPercent: number;
    criticalityScheduleAdherence: number;
    budgetResourceSum: number;
    actualResourceSum: number;
    remainingResourceSum: number;
}
